<template>
  <div>
    <div class="spinner-wrapper" v-if="loading">
      <div class="spinner-border text-primary mb-1" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-else>
      <div v-if="organizationId">
        <section
          v-if="organization.featured"
          class="overlay overlay-info overlay-80 mb-10 pt-10 pt-md-15 pb-7 pb-md-15 background-cover"
          v-bind:style="{ backgroundImage: `url(${featuredImage})` }"
        >
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-12 col-md-8 text-center">
                <h1 class="display-1 font-weight-bold text-white mb-6 mt-n3">
                  {{ organization.name }}
                </h1>
              </div>
            </div>
          </div>
          <div class="position-absolute right-0 bottom-0 left-0">
            <div
              class="position-relative shape shape-bottom shape-fluid-x svg-shim text-white"
            >
              <svg
                viewBox="0 0 2880 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 48h2880V0h-720C1442.5 52 720 0 720 0H0v48z"
                  fill="#f1effb"
                />
              </svg>
            </div>

            <div class="position-absolute center bottom-0">
              <a
                class="btn btn-light btn-rounded-circle lift"
                data-toggle="smooth-scroll"
                @click.prevent="goToDonate"
                href="#payment-card"
              >
                <i class="fe fe-arrow-down"></i>
              </a>
            </div>
          </div>
        </section>
        <section v-else>
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-12 col-md-8 text-center">
                <h1 class="my-10">
                  Donate to
                  <span class="font-weight-bold">{{ organization.name }}</span>
                </h1>
              </div>
            </div>
          </div>
        </section>

        <div class="container">
          <div class="text-center mb-5 d-block d-sm-none">
            <a
              data-toggle="smooth-scroll"
              @click.prevent="goToDonate"
              href="#payment-card"
              class="btn btn-success"
              >Donate Now</a
            >
          </div>
          <div class="mb-10" v-if="organization.video">
            <vue-plyr class="card">
              <div class="plyr__video-embed">
                <iframe
                  :src="organization.video.url"
                  allowfullscreen
                  allowtransparency
                  allow="autoplay"
                ></iframe>
              </div>
            </vue-plyr>
          </div>
          <div
            class="row"
            :class="[
              organization.actual_content &&
              organization.actual_content.content &&
              organization.actual_content.content.trim() !== ''
                ? 'justify-content-between'
                : 'justify-content-center',
            ]"
            v-if="!donation.finished"
          >
            <div class="col-12 col-md-6 align-self-stretch">
              <span
                v-if="
                  organization.actual_content &&
                  organization.actual_content.content &&
                  organization.actual_content.content.trim() !== ''
                "
                v-html="organization.actual_content.content"
              ></span>
              <div
                v-if="
                  (organization.number != '' && organization.number != 0) ||
                  (organization.phone && organization.phone != '') ||
                  (organization.email && organization.email != '') ||
                  (organization.website && organization.website != '')
                "
                class="card shadow-dark-lg mb-5"
              >
                <div class="card-body">
                  <h4>{{ organization.name }}</h4>
                  <p
                    v-if="organization.number != '' && organization.number != 0"
                  >
                    <b>Organization Number:</b> {{ organization.number }}
                  </p>
                  <p v-if="organization.phone && organization.phone != ''">
                    <b>Phone:</b> {{ organization.phone }}
                  </p>
                  <p v-if="organization.email && organization.email != ''">
                    <b>Email:</b> {{ organization.email }}
                  </p>
                  <p v-if="organization.website && organization.website != ''">
                    <b>Website:</b>&nbsp;
                    <a :href="organization.website">{{
                      organization.website
                    }}</a>
                  </p>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div
                class="card shadow-dark-lg mb-5"
                id="payment-card"
                ref="payment-card"
              >
                <form class="card-body">
                  <transition name="slide">
                    <div v-show="!donation.creditCard">
                      <AmountSelector
                        :donation="donation"
                        :organization="organization"
                      />
                      <div class="d-flex align-items-edges mb-5">
                        <div
                          class="custom-control col-auto custom-switch align-self-center"
                        >
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            id="tip"
                            v-model="donation.tip"
                            true-value="1"
                            false-value="0"
                          />
                          <label class="custom-control-label" for="tip"
                            >I wish to add 5% to my donation to help offset
                            processing fees
                          </label>
                        </div>
                      </div>
                      <!-- <div
                        class="form-group mb-3 d-flex align-items-center alert border-primary"
                      >
                        <i
                          class="text-primary mr-3 fa-4x"
                          :class="[
                            $store.state.country == 'can'
                              ? 'fab fa-canadian-maple-leaf'
                              : 'fad fa-flag-usa',
                          ]"
                        ></i>
                        <small class="text-muted">
                          <p class="mb-0">
                            You're donating through
                            <span v-if="$store.state.country == 'us'"
                              >Ne'eman Foundation USA</span
                            ><span v-else>The Emunim Fund CANADA</span>.
                            <a href="#" @click.prevent="toggleCountry"
                              >Click here</a
                            >
                            if you prefer to donate through
                            <span v-if="$store.state.country == 'us'"
                              >The Emunim Fund CANADA</span
                            ><span v-else>Ne'eman Foundation USA</span>
                          </p>
                        </small>
                      </div> -->
                      <div class="form-group">
                        <div class="custom-control custom-switch">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            id="allocate"
                            v-model="donation.allocate"
                            true-value="1"
                            false-value="0"
                          />
                          <label class="custom-control-label" for="allocate">
                            Allocate/Dedicate Your Donation
                          </label>
                        </div>
                        <textarea
                          v-if="donation.allocate == 1"
                          v-model="donation.allocation"
                          placeholder="Write your allocation..."
                          class="form-control my-2"
                        ></textarea>
                      </div>
                      <div class="form-group mb-0">
                        <button
                          @click="continueWithCard"
                          type="button"
                          class="btn btn-card btn-block"
                        >
                          <i class="far fa-credit-card"></i> Credit card
                        </button>
                        <form
                          action="https://www.paypal.com/cgi-bin/webscr"
                          method="post"
                        >
                          <input
                            type="hidden"
                            name="currency_code"
                            v-model="currency_code"
                          />
                          <input
                            type="hidden"
                            name="item_name"
                            v-model="organization.name"
                          />
                          <input
                            name="business"
                            type="hidden"
                            :value="[
                              $store.state.country == 'can'
                                ? 'theneemanfoundation@gmail.com'
                                : 'neemanusa@gmail.com',
                            ]"
                          />
                          <input
                            name="custom"
                            id="pp-custom"
                            type="hidden"
                            :value="organization.id + '|' + donation.allocation"
                          />
                          <input type="hidden" name="no_shipping" value="1" />
                          <input
                            name="cmd"
                            type="hidden"
                            :value="[
                              donation.monthly == 0
                                ? '_donations'
                                : '_xclick-subscriptions',
                            ]"
                          />
                          <input
                            name="amount"
                            type="hidden"
                            v-model="donation.amount"
                            v-if="donation.monthly == 0"
                          />
                          <template v-else>
                            <input
                              type="hidden"
                              name="a3"
                              v-model="donation.amount"
                            />
                            <input type="hidden" name="p3" value="1" />
                            <input type="hidden" name="t3" value="M" />
                            <input type="hidden" name="src" value="1" />
                            <input
                              type="hidden"
                              name="srt"
                              :value="donation.months"
                            />
                            <input name="no_note" type="hidden" value="1" />
                          </template>
                          <input name="lc" type="hidden" value="CA" />
                          <input name="bn" type="hidden" value="PP-BuyNowBF" />
                          <input
                            name="return"
                            type="hidden"
                            value="https://neemanfoundation.com/thank_you/"
                          />
                          <input
                            name="notify_url"
                            type="hidden"
                            value="https://app.neemanfoundation.com/gateway/paypal/"
                          />
                          <button
                            type="submit"
                            @click="
                              if (donation.nameAmount > 0) {
                                donation.amount =
                                  donation.tip == 1
                                    ? donation.nameAmount * 1.05
                                    : donation.nameAmount;
                              } else {
                                donation.amount =
                                  donation.tip == 1
                                    ? donation.amount * 1.05
                                    : donation.amount;
                              }
                            "
                            class="btn btn-paypal btn-block mt-1"
                          >
                            <i class="fab fa-cc-paypal"></i> PayPal
                          </button>
                        </form>
                      </div>
                      <p class="mt-4 mb-0 text-center">
                        For other ways to donate
                        <router-link to="/how-to-donate"
                          >CLICK HERE</router-link
                        >
                        <br />
                        <span class="text-muted">
                          Donations to Ne'eman Foundation are tax deductible by
                          law.
                        </span>
                      </p>
                    </div>
                  </transition>
                  <transition name="slide">
                    <div
                      id="credit-card-form"
                      class="overflow-auto h-100"
                      v-if="donation.creditCard"
                    >
                      <credit-card-form
                        :donation.sync="donation"
                        :organization="organization"
                      />
                    </div>
                  </transition>
                </form>
                <div class="secure-footer">
                  <div
                    class="text-muted d-flex justify-content-center align-items-center"
                  >
                    <i class="fad fa-lock-alt fa-2x mr-3 text-success"></i>
                    <span style="line-height: 1">Safe and Secure Payments</span>
                    <i class="fab fa-lg ml-5 fa-cc-visa text-info"></i>
                    <i class="fab fa-lg ml-2 fa-cc-amex text-info"></i>
                    <i class="fab fa-lg ml-2 fa-cc-mastercard text-info"></i>
                    <i class="fab fa-lg ml-2 fa-cc-diners-club text-info"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            id="thank-you-wrapper"
            v-else
            class="py-10 px-10 border border-default rounded mb-10 text-center shadow-lift"
          >
            <h1 class="text-center mb-0">Thank you for your support</h1>
          </div>
        </div>
      </div>
      <div v-else class="container alert border-info mt-10 text-center p-5">
        Sorry, Unfortunately This organization doesn't exist in the
        {{ country }} site
        <br />
        <br />

        <a href="#" @click.prevent="switchCountry" class="btn btn-success">
          Please click here for the Ne'eman
          <template v-if="country == 'USA'"> Canada</template>
          <template v-if="country == 'Canada'"> USA </template>
          page.
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../event-bus.js";
import CreditCardForm from "../components/CreditCardForm";
import VuePlyr from "vue-plyr";
import "vue-plyr/dist/vue-plyr.css";
import AmountSelector from "../components/AmountSelector";

export default {
  metaInfo() {
    return {
      title: this.organization.name,
    };
  },
  components: {
    CreditCardForm,
    VuePlyr,
    AmountSelector,
  },
  props: {},
  data() {
    return {
      currency_code: "",
      currencies: [],
      organization: {},
      donation: {
        currency: {},
        amount: 50,
        months: 12,
        allocate: 0,
        allocation: "",
        finished: false,
        creditCard: false,
        cardName: "",
        cardEmail: "",
        cardNumber: "",
        cardMonth: "",
        cardYear: "",
        cardCvv: "",
        city: "",
        state: "",
        zip: "",
        country_id: "",
        address: "",
        monthly: 0,
        nameAmount: "",
      },
      allocation: "",
      loading: true,
    };
  },
  watch: {
    $route() {
      this.getOrganition();
    },
    // "$store.state.country": function () {
    //   this.change_currency();
    // },
  },
  mounted() {
    this.getOrganition();
  },
  unmounted() {
    this.donation.finished = false;
  },
  computed: {
    amnts() {
      if (this.organization.amount_type_id == 2) {
        return JSON.parse(this.organization.amounts);
      } else {
        return [50, 100, 180, 250, 500, 1000, 1800];
      }
    },
    organizationId() {
      return this.organization[this.$store.state.country + "_code"];
    },
    featuredImage() {
      return (
        this.$store.state.api_url +
        "/images/organizations/" +
        this.organization.id +
        "/larg_" +
        this.organization.featured.file_name
      );
    },
    country() {
      return this.$store.state.country == "can" ? "Canada" : "USA";
    },
  },
  methods: {
    switchCountry() {
      EventBus.$emit("switchCountry");
    },
    getOrganition() {
      let self = this;
      this.axios
        .get(window.API_URL + "organizations/" + this.$route.params.id)
        .then(function (response) {
          self.organization = response.data;
          self.loading = false;
          self.donation.amount = self.amnts[0];
        })
        .catch(function (error) {});
    },
    continueWithCard() {
      this.donation.creditCard = true;
      if (this.donation.nameAmount > 0) {
        this.donation.amount = this.donation.nameAmount;
      }
    },
    toggleCountry() {
      EventBus.$emit("switchCountry");
    },
    goToDonate() {
      this.$refs["payment-card"].scrollIntoView({ behavior: "smooth" });
    },
  },
};
</script>
<style lang="scss">
.content {
  p,
  h1,
  h2,
  h3,
  h4,
  .h1,
  .h2,
  .h3,
  .h4,
  ul,
  ol {
    color: #fff;
  }
}
// .amount-selector {
//   .btn.border-right {
//     border-right: 0.5px solid #2a8a6c !important;
//   }
//   .btn.border-left {
//     border-left: 0.5px solid #2a8a6c !important;
//   }
//   .btn.active {
//     background: #389e7f;
//     box-shadow: inset 0 0 10px rgba($color: #000000, $alpha: 0.3) !important;
//   }
//   .btn:not([class*="btn-outline"]) {
//     border-radius: 0;
//   }
//   .btn-row.first-row {
//     clear: both;
//     .btn {
//       border-bottom: 0.5px solid #2a8a6c !important;
//     }
//     .btn:first-child {
//       border-top-left-radius: 5px;
//     }
//     .btn:last-child {
//       border-top-right-radius: 5px;
//     }
//   }
//   .btn-row.last-row {
//     .btn {
//       border-top: 0.5px solid #2a8a6c !important;
//     }
//     .btn:first-child {
//       border-bottom-left-radius: 5px;
//     }
//     .btn:last-child {
//       border-bottom-right-radius: 5px;
//     }
//   }
// }
.vertical-input-group .input-group:first-child {
  padding-bottom: 0;
}
.vertical-input-group .input-group:first-child * {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.vertical-input-group .input-group:last-child {
  padding-top: 0;
}
.vertical-input-group .input-group:last-child * {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.vertical-input-group .input-group:not(:last-child):not(:first-child) {
  padding-top: 0;
  padding-bottom: 0;
}
.vertical-input-group .input-group:not(:last-child):not(:first-child) * {
  border-radius: 0;
}
.vertical-input-group .input-group:not(:first-child) * {
  border-top: 0;
}
.btn.btn-card {
  background-color: #263771;
  color: #fff;
}
.btn.btn-paypal {
  background-color: #0070ba;
  color: #fff;
}
.btn.btn-card:hover {
  background-color: darken(#263771, 10);
  color: #fff;
}
.btn.btn-paypal:hover {
  background-color: darken(#0070ba, 10);
  color: #fff;
}
.spinner-wrapper {
  display: block;
  width: 100%;
  height: 70vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.background-cover {
  background-size: cover;
  background-position: center;
}
.form-group {
  .btn-success {
    font-size: 25px;
    span {
      font-size: 14px;
      opacity: 0.7;
    }
  }
}
h3 .custom-control {
  margin-top: 3px;
}
h3 .custom-control-label {
  color: #161c2d;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  line-height: 1.7;
}
.secure-footer {
  background-color: rgba(0, 0, 0, 0.03);
  border-top: 1px solid rgba(0, 0, 0, 0.125);
  margin: 10px 0 0;
  padding: 30px 50px;
}
.custom-control-input:checked ~ .custom-control-label::before {
  background-color: #42ba96;
}
.custom-control-input:checked ~ .custom-control-label::after {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='green' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E");
}
#thank-you-wrapper.rounded {
  border-radius: 30px !important;
  background: rgba(255, 255, 255, 0.5);
}
@media (max-width: 544px) {
  .btn {
    padding: 0.8125rem 0.25rem;
  }
}
.plyr {
  border-radius: 10px;
}
// #months {
//   display: inline-block;
//   text-align: center;
//   margin: 0 3px;
//   width: 3em;
//   box-sizing: content-box;
//   padding: 0 2px;
//   height: 24px;
//   border-color: #ddd;
// }
// #amount {
//   -webkit-user-select: text;
//   user-select: text;
// }
</style>